import { ScheduleIndexResponse, SchedulesTransformedShape } from '../services/dashboardApi';
import { getShortDateFromDBDate } from './dashboard.utils';
import { dbDateToJsDate, jsDateToDbDate } from '@/common/utils/app.utils';

export type DropDownReducedItemsShape = {
  range: string;
  year: number;
  startMonth: string;
};

export function reduceSchedulesResponseToLabels(schedules: ScheduleIndexResponse) {
  const schedulesList = schedules
    .map((schedule) => {
      const left = getShortDateFromDBDate(schedule.startMonth);
      const right = getShortDateFromDBDate(schedule.endMonth);

      if (left && right) {
        return {
          range: `${left} - ${right}`,
          year: schedule.startYear,
          startMonth: schedule.startMonth,
        };
      }

      return null;
    })
    .filter((item) => item);

  return schedulesList as DropDownReducedItemsShape[];
}

export function getMonthRangeByYear(year: number) {
  const left = getShortDateFromDBDate(`${year}09`);
  const right = getShortDateFromDBDate(`${year + 1}08`);

  return `${left} - ${right}`;
}

export function sortScheduleResponseByYear(schedules: ScheduleIndexResponse) {
  return [...schedules].sort((left, right) => right.startYear - left.startYear);
}

function countMonthsBetweenDates(startDate: Date, endDate: Date) {
  const startYear = startDate.getFullYear();
  const startMonth = startDate.getMonth();
  const endYear = endDate.getFullYear();
  const endMonth = endDate.getMonth();

  const totalMonths = (endYear - startYear) * 12 + (endMonth - startMonth) + 1;

  return totalMonths;
}

function addMonthsToDate(date: Date, monthToAdd: number) {
  const copied = new Date(date);
  copied.setMonth(date.getMonth() + monthToAdd);

  return copied;
}

export function createRangeFromStartEndMonths(start: string, end: string) {
  const MAX_MONTHS = 60;
  const range = [];

  if (dbDateToJsDate(start) <= dbDateToJsDate(end)) {
    const totalMonths = countMonthsBetweenDates(dbDateToJsDate(start), dbDateToJsDate(end));
    if (totalMonths > MAX_MONTHS) {
      return null;
    }
    const firstDate = dbDateToJsDate(start);
    for (let i = 0; i < totalMonths; i++) {
      const nextMonth = addMonthsToDate(firstDate, i);
      range.push(jsDateToDbDate(nextMonth));
    }

    return range;
  }

  return null;
}

export function transformSchedulesResponse(response: ScheduleIndexResponse) {
  const transformed = {} as SchedulesTransformedShape;
  response.forEach((schedule) => {
    const range = createRangeFromStartEndMonths(schedule.startMonth, schedule.endMonth);
    if (!range) {
      throw new Error('Could not calculate range');
    }

    transformed[schedule.startYear] = {
      year: schedule.startYear,
      months: range as string[],
    };
  });

  return transformed;
}

export function getSchoolYearFromSelectedPeriod(
  period: string,
  transformed: SchedulesTransformedShape,
) {
  let year: string | null = null;
  let month: string | null = null;
  for (const schoolYear in transformed) {
    const range = transformed[schoolYear].months;
    if (range.includes(period)) {
      year = schoolYear;
      month = range[0];
      break;
    }
  }

  return { year, month };
}
